import contentApi from '@/services/plataforma/content';
import CategoryType from '@/helpers/contentCategory';
import TopicTypeHelper from '@/helpers/contentType';

const getTopicByTopicId = (topics, topicId) => {
  let itemSelected = {};

  topics.map(itemFirstLevel => {
    if (itemFirstLevel.id === topicId) {
      itemSelected = itemFirstLevel;
    }

    if (itemFirstLevel.children) {
      itemFirstLevel.children.map(itemSecondLevel => {
        if (itemSecondLevel.id === topicId) {
          itemSelected = itemSecondLevel;
        }

        if (itemSecondLevel.children) {
          itemSecondLevel.children.map(itemThirdLevel => {
            if (itemThirdLevel.id === topicId) {
              itemSelected = itemThirdLevel;
            }

            if (itemThirdLevel.children) {
              itemThirdLevel.children.map(itemFourthLevel => {
                if (itemFourthLevel.id === topicId) {
                  itemSelected = itemFourthLevel;
                }
              });
            }
          });
        }
      });
    }
  });

  return itemSelected;
};

export default {
  actionGetMenu({ commit, dispatch }, contentId) {
    return contentApi.getMenu(contentId)
      .then(async (response) => {
        commit('plataforma/courses/SET_USER_PERMISSIONS', response.data.permissions, { root: true });
        commit('SET_MENU', response.data);

        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionCreateContent({ commit }, { academicMainId, templateName }) {
    return contentApi.createContent({ academicMainId, templateName })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetCollabURL({ commit }, data) {
    return contentApi.getCollabURL(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetCollabRecords({ commit }, data) {
    return contentApi.getCollabRecords(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetCollabRecordURL({ commit }, data) {
    return contentApi.getCollabRecordURL(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  getWebconferenceProvider({ commit }) {
    return contentApi.getWebconferenceProvider()
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionReintegrateWebconference({ commit }, { topicId, data }) {
    return contentApi.reintegrateWebconference(topicId, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionSetWebconferenceIntegration({ commit }, { topicId, value }) {
    commit('UPDATE_WEBCONFERENCE_INTEGRATION_IN_MENU', { topicId, value });
  },
  actionCreateTopic({ commit }, { contentId, data }) {
    return contentApi.createTopic(contentId, data)
      .then((response) => {
        commit('SET_NEW_TOPIC_IN_MENU', { ...response.data, isEditing: !!((response.data.categoryTypeId === CategoryType.LINKS || response.data.categoryTypeId === CategoryType.DISCURSIVE_EXERCISE || response.data.categoryTypeId === CategoryType.HTML || response.data.categoryTypeId === CategoryType.ORGANIZATION)) });
        response.data.content
          ? commit('SET_VERSION', response.data.content.version)
          : commit('SET_VERSION', response.data.version);

        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionDeleteTopic({ commit }, { contentId, topic, layout = null, version }) {
    return contentApi.deleteTopic(contentId, topic, { layout, version })
      .then((response) => {
        commit('DELETE_TOPIC', topic);
        commit('SET_VERSION', response.data.version);
        if (layout) {
          commit('SET_NEW_LAYOUT', { topic, layout });
        }

        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetContentByTopicId({ commit }, { contentId, topicId }) {
    return contentApi.getContentByTopicId(contentId, topicId)
      .then((response) => {
        commit('SET_SELECTED_TOPIC_WITH_CONTENT', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetContentByTopicIdWithoutSetSelected({ commit }, { contentId, topicId }) {
    return contentApi.getContentByTopicId(contentId, topicId)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionPatchContentHtmlByTopicId({ commit, rootState }, params) {
    let topicToRollback = {};
    let selected = {};

    if (rootState.plataforma.content.selectedTopic.children && rootState.plataforma.content.selectedTopic.id !== params.topicId) {
      selected = rootState.plataforma.content.selectedTopic.children.filter(topic => topic.id === params.topicId)[0];
    } else {
      selected = rootState.plataforma.content.selectedTopic;
    }

    if (selected.id) {
      topicToRollback = JSON.parse(JSON.stringify(selected));
    }

    commit('SET_CONTENT_IN_SELECTED_TOPIC', params);

    return contentApi.patchContentHtmlByTopicId(params)
      .then((response) => {
        if (response.status === 200) {
          selected.topicTypeId === TopicTypeHelper.PAGE && commit('UPDATE_GRADE_BOOK_MODULE', { topicId: params.topicId, content: response.data });
          commit('SET_VERSION', response.data.version);
        }

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        commit('SET_CONTENT_IN_SELECTED_TOPIC', { ...params, content: topicToRollback.content });
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionUpdateTopic({ commit }, { contentId, data, newElement = null }) {
    return contentApi.updateTopic(contentId, data)
      .then((response) => {
        commit('UPDATE_TOPIC_IN_MENU', { topic: response.data, newElement });
        response.data.content
          ? commit('SET_VERSION', response.data.content.version)
          : commit('SET_VERSION', response.data.version);

        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionPatchTopic({ commit, rootState }, { contentId, topicId, content }) {
    let topicToRollback;

    const selected = getTopicByTopicId(rootState.plataforma.content.menuTopics, topicId);

    if (selected.id) {
      topicToRollback = Object.assign({}, selected);
    }

    commit('UPDATE_TOPIC_IN_MENU', { topic: { id: topicId, ...content } });

    return contentApi.patchTopic(contentId, topicId, { ...content })
      .then((response) => {
        commit('SET_VERSION', response.data.version);
        return Promise.resolve();
      })
      .catch((e) => {
        commit('UPDATE_TOPIC_IN_MENU', { topic: { id: topicId, title: topicToRollback.title, isVisible: topicToRollback.isVisible } });
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionForceDownload(_, { url, fileName }) {
    return contentApi.getFile(url)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        return Promise.resolve();
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetTopicsOfPageByPageId({ commit }, { contentId, itemId, selectedItem }) {
    return contentApi.getTopicsOfPageByPageId({ contentId, topicId: selectedItem.id })
      .then((response) => {
        const params = {
          ...selectedItem,
          children: response.data
        };

        if (itemId) {
          const topic = params.children.find(a => a.id === itemId);
          topic.isSelected = true;
        }

        commit('SET_SELECTED_TOPIC_WITH_CONTENT', params);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionCreatePageWithChildrens({ commit }, { contentId, data }) {
    return contentApi.createPageWithChildrens({ contentId, data })
      .then((response) => {
        commit('SET_NEW_TOPIC_IN_MENU', {
          ...response.data,
          children: response.data.children.map(topic => {
            return { ...topic, isEditing: false };
          }),
          isEditing: true
        });
        commit('SET_VERSION', response.data.content.version);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetPostsByTopicId({ commit }, { topicId, contentId }) {
    return contentApi.getPostsByTopicId(topicId, contentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err);
      });
  },
  actionPostCommentInForum({ commit }, { topicId, enrollmentId, params }) {
    return contentApi.postCommentInForum(topicId, enrollmentId, params)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionLikeTopic({ commit }, { topicId, enrollmentId }) {
    return contentApi.likeTopic(topicId, enrollmentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionDislikeTopic({ commit }, { topicId, enrollmentId }) {
    return contentApi.dislikeTopic(topicId, enrollmentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionLikeComment({ commit }, { topicId, commentId, enrollmentId }) {
    return contentApi.likeComment(topicId, commentId, enrollmentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionDislikeComment({ commit }, { topicId, commentId, enrollmentId }) {
    return contentApi.dislikeComment(topicId, commentId, enrollmentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionPatchCommentOfTopic({ commit }, { topicId, postId, enrollmentId, data }) {
    return contentApi.patchCommentOfTopic(topicId, postId, enrollmentId, data)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionCreateQuestion({ commit }, { contentId, selectedItem, data }) {
    return contentApi.createQuestion({ contentId, topicId: selectedItem.id, data })
      .then((response) => {
        commit('UPDATE_TOPIC_IN_MENU', {
          topic: {
            id      : selectedItem.id,
            content : {
              ...selectedItem.content,
              questions: response.data.questions
            }
          }
        });
        commit('SET_VERSION', response.data.version);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionUpdateQuestion({ commit }, { contentId, selectedItem, data }) {
    return contentApi.updateQuestion({ contentId, topicId: selectedItem.id, data })
      .then((response) => {
        commit('UPDATE_TOPIC_IN_MENU', {
          topic: {
            id      : selectedItem.id,
            content : {
              ...selectedItem.content,
              questions: response.data.questions
            }
          }
        });
        commit('SET_VERSION', response.data.version);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionDeleteQuestion({ commit }, { contentId, selectedItem, data }) {
    return contentApi.deleteQuestion({ contentId, topicId: selectedItem.id, questionId: data.id })
      .then((response) => {
        commit('UPDATE_TOPIC_IN_MENU', {
          topic: {
            id      : selectedItem.id,
            content : {
              ...selectedItem.content,
              questions: response.data
            }
          }
        });

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionCreateQuiz({ commit }, { contentId, params }) {
    return contentApi.createQuiz({ contentId, params })
      .then((response) => {
        commit('SET_NEW_TOPIC_IN_MENU', { ...response.data, isEditing: false });
        commit('SET_VERSION', response.data.content.version);

        return Promise.resolve(response);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionReorderTopics({ commit }, params) {
    return contentApi.reorderTopics(params)
      .then((response) => {
        commit('CHANGE_SEQUENCE_OF_TOPIC', { element: params.dataToMutation.element, oldIndex: params.dataToMutation.oldIndex, newIndex: params.dataToMutation.newIndex, layout: params.dataToMutation.layout });
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionsList({ _ }, params) {
    return contentApi.getCorrectionsList(params)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionContext({ _ }, { contentId, topicId, isToHideEnrollments }) {
    return contentApi.getForumCorrectionContext(contentId, topicId, !!isToHideEnrollments)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionByEnrollmentId({ _ }, { contentId, correctionId, enrollmentId }) {
    return contentApi.getAnswersByEnrollmentIdAndTopicId(contentId, correctionId, enrollmentId)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionCopyContent({ commit }, { destinyMainId, originMainId, integration }) {
    return contentApi.copyContent({ destinyMainId, originMainId, integration })
      .then((result) => {
        return Promise.resolve(result);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionProcessGrade(_, topicId) {
    return contentApi.processGrade(topicId)
      .then(() => {
        return Promise.resolve();
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionChangeMultipleGrades({ commit }, params) {
    return contentApi.changeMultipleGrades(params)
      .then((result) => {
        commit('SET_VERSION', result.data.version);
        commit('SET_MULTIPLE_GRADES_ON_QUIZ', params);
        return Promise.resolve();
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetContextLtiByUrl({ _ }, url) {
    return contentApi.getContextLtiByUrl(url)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionPrintContent({ _ }, params) {
    return contentApi.printContent(params)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionCreateTopicEnrollmentException({ _ }, params) {
    return contentApi.createTopicEnrollmentException(params)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  }
};
